


















import { Component, Vue } from "vue-property-decorator";
@Component
export default class Tbxz extends Vue {
    content = [
        "本报告书仅限企业每年向市场监督管理部门报送年度报告,并向社会公示时使用。每年1月1日至6月30日，企业应当通过国家企业信用信息公示系统报送上一年度报告。\n",
        "年度报告内容应真实反映企业存续经营实际情况，企业对其公示信息的真实性、及时性负责。\n",
        "企业发现其年度报告内容不准确的，应于报告当年的6月30日前进行更正。更正前后的信息同时公示。6月30日后，年度报告的更正功能关闭。\n",
        "本报告书所有信息项均为必填项，如果该项内容确无信息，请填写“无”。\n",
        "企业填报的通信地址、邮政编码、联系电话、电子邮箱、存续状态、网址、网站信息均为报送时的信息，其余信息为所报告年度12月31日的信息。\n",
        "本报告书填报中涉及到金额信息项的以万元为单位，可保留小数点后六位。\n",
        "股东（发起人）的姓名或者名称应当与报告年度在市场监督管理部门登记的姓名或者名称一致。\n",
        "每一个股东（发起人）的出资信息只需填报一条，股东（发起人）认缴和实缴出资额为截至报告年度12月31日的累计数额，其中外商投资企业认缴和实缴出资额的币种与注册资本一致；认缴和实缴出资时间为截至报告年度12月31日最后一次认缴和实缴时间，出资方式可以多选。\n",
        "企业资产状况信息，应当是企业年度资产负债表和损益表（利润表）中的期末数；纳税总额为企业全年实缴各类税金的总和。\n",
        "企业主营业务活动指企业实际从事的主要业务活动。\n",
        "参保各险种人数指报告期末参加社会保险的职工人数（不含离退休人数）。单位缴费基数指报告期内单位缴纳社会保险费的工资总额，按缴费人员的应缴口径计算。本期实际缴费金额指报告期内单位实际缴纳的社会保险费，不包括补缴欠费和跨年度（或跨季度）的预缴金额。单位累计欠缴金额指截至报告期末单位累计欠缴各项社会保险费金额（本金）。\n",
        "企业生产经营情况、对外担保、从业人数、社保缴费信息为非强制性公示的事项，可选择是否向社会公示。其中，对外担保信息可以选择某条具体信息是否向社会公示。\n",
        "表中“高校毕业生人数”是指报告期内录用的毕业两年内的高校毕业生；“退役士兵人数、残疾人人数、失业人员再就业人数”是指报告期内录用的退役士兵、残疾人数、失业人员再就业人数。此类信息为不公示信息。",
        "党建信息为不公示信息，主要采集企业党组织的建立情况，但属于抽查范围。其中，中共党员（包括预备党员）人数，为截至年度报告年份12月31日的人数。"
    ];
}
